import { useThree } from "@react-three/fiber";
import { OrbitControls as DreiOrbitControls} from "@react-three/drei";
import { forwardRef, useImperativeHandle, useRef } from "react";
import * as THREE from 'three';

const DEFAULT_ORBIT_CONTROLS_TARGET = new THREE.Vector3(0, 0, 0);

type OrbitControlsProps = {
    selectedModelUUID: string | null;
};

export type LayerEditorOrbitControlsRef = {
    setModelCenterToOrbitControlsTarget: (uuid: string) => void;
    zoomToModel: (modelUUID: string) => void;
    setCameraPosition: (position: THREE.Vector3) => void;
};

export const OrbitControls = forwardRef<LayerEditorOrbitControlsRef, OrbitControlsProps>(
    (
        { selectedModelUUID }: OrbitControlsProps,
        orbitControlsRef
    ) => {
        const scene = useThree(state => state.scene);
        const camera = useThree(state => state.camera);
        const dreiOrbitControlsRef = useRef();

        useImperativeHandle(orbitControlsRef, () => ({
            setModelCenterToOrbitControlsTarget: (uuid: string) => {
                const model = scene.getObjectByProperty('uuid', uuid);
                
                if (model) {
                    const box3 = new THREE.Box3().setFromObject(model);
                    let center = new THREE.Vector3();
                    box3.getCenter(center);

                    if (dreiOrbitControlsRef.current) (dreiOrbitControlsRef.current as any).target.copy(center);
                } else {
                    //if (dreiOrbitControlsRef.current) (dreiOrbitControlsRef.current as any).target.copy(DEFAULT_ORBIT_CONTROLS_TARGET);
                }
            },
            zoomToModel: (modelUUID: string) => {
                const object = scene.getObjectByProperty('uuid', modelUUID);

                if (object) {
                    
                    if (dreiOrbitControlsRef.current) {
                        const box = new THREE.Box3().setFromObject(object);
                        const sphere = box.getBoundingSphere(new THREE.Sphere());

                        if (dreiOrbitControlsRef.current) (dreiOrbitControlsRef.current as any).target.copy(sphere.center);
                        
                        const direction = new THREE.Vector3().subVectors(camera.position, (dreiOrbitControlsRef.current as any).target).normalize();

                        const distanceFactor = 1.2;
                        const newCameraPos = sphere.center.clone().add(direction.multiplyScalar(sphere.radius * distanceFactor));
                        camera.position.copy(newCameraPos);
                    }
                    
                }
            },
            setCameraPosition: (position: THREE.Vector3) => {
                camera.position.copy(position);
            }
        }), [scene, camera]);

        /*useEffect(() => {
            if ((orbitControlsRef as React.MutableRefObject<LayerEditorOrbitControlsRef>).current && selectedModelUUID)
                (orbitControlsRef as React.MutableRefObject<LayerEditorOrbitControlsRef>).current.setModelCenterToOrbitControlsTarget(selectedModelUUID);
        }, [selectedModelUUID, orbitControlsRef]);*/

        return (
            <DreiOrbitControls
                makeDefault
                enableDamping={false}
                target={DEFAULT_ORBIT_CONTROLS_TARGET}
                ref={dreiOrbitControlsRef}
            />
        );
    }
);